import React, {useEffect, useState} from 'react'
import {Box, Avatar, Divider} from '@mui/material'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {
    useGetCurrentUserQuery,
    useGetUserQuery,
    useUpdateProfileMutation,
    useUploadImageMutation,
} from 'store/Store'
import {signupFieldSection} from 'constants/FormField/signupField'
import FormSection from 'components/Control/Form/FormSection'
import Button from 'components/Control/Button'
import Loader from 'components/Display/Loader/Loader'
import {onSubmit} from 'services/utils/toastUtils'

const ProfileSettings = () => {
    const {t} = useTranslation()
    const {data: userToken} = useGetCurrentUserQuery()
    const {_id} = userToken || {}
    const {data: user, isLoading} = useGetUserQuery(_id, {skip: !_id})
    const [doUpdateProfile] = useUpdateProfileMutation()
    const [doUploadImage] = useUploadImageMutation()
    const [imageUrl, setImageUrl] = useState('/images/avatar-placeholder.png')

    const methods = useForm({defaultValues: user})
    const {reset, handleSubmit, setValue} = methods

    useEffect(() => {
        if (user) {
            reset(user)
            setImageUrl(user.profileImage || '/images/avatar-placeholder.png')
        }
    }, [user, reset])

    const handleImageUpload = async (event) => {
        const file = event.target.files[0]
        if (!file) return
        const form = new FormData()
        form.append('files', file)
        try {
            const result = await doUploadImage(form).unwrap()
            if (result.files?.length > 0) {
                setImageUrl(result.files[0].fullLink)
                setValue('profileImage', result.files[0].link)
            }
        } catch (error) {
            console.error('Image upload failed:', error)
        }
    }

    const submitEdit = handleSubmit((itemData) =>
        onSubmit({itemData, itemName: 'user', doSomething: doUpdateProfile, commandType: 'edit', t})
    )

    if (isLoading || !user) return <Loader show={true} />

    return (
        <Box>
            {/* Avatar row */}
            <Box display="flex" alignItems="center" gap={2} mb={3}>
                <Avatar
                    src={imageUrl}
                    alt="Profile"
                    sx={{width: 64, height: 64}}
                />
                <Button variant="outlined" component="label" size="small">
                    {t('profile.image')}
                    <input
                        hidden
                        type="file"
                        accept=".jpg,.jpeg,.png,.svg"
                        onChange={handleImageUpload}
                    />
                </Button>
            </Box>
            <Divider sx={{mb: 3}} />

            {/* Form */}
            <FormSection
                fields={signupFieldSection}
                methods={methods}
                i18nCategory="signup"
            />

            {/* Save */}
            <Box display="flex" justifyContent="flex-end" mt={3}>
                <Button variant="contained" onClick={submitEdit}>
                    {t('profile.saveChanges')}
                </Button>
            </Box>
        </Box>
    )
}

export default ProfileSettings
